import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import {
  GetPolicyListParams,
  GetQuotationyListParams,
  PolicyListResponse,
  UpdatePolicyAddressBody,
} from 'api/types/policies'

class Policies {
  // get policies List
  async getPoliciesList({
    brokerNo,
    policyNo,
    nif,
    product,
    status,
    page,
    output,
  }: GetPolicyListParams): Promise<PolicyListResponse | (AxiosError | Error)> {
    let url
    if (output) {
      url = `${APIRoutes.policy.getPoliciesList}?brokerNo=${brokerNo}`
    } else {
      url = `${APIRoutes.policy.getPoliciesList}?brokerNo=${brokerNo}&skip=${
        page * 50
      }&take=50`
    }

    if (product) {
      url += `&product=${product}`
    }
    if (status) {
      url += `&status=${status}`
    }
    if (nif) {
      url += `&nif=${nif}`
    }
    if (policyNo) {
      url += `&policyNo=${policyNo}`
    }
    if (output) {
      url += `&output=${output}`
    }

    return ApiProvider.getRequest(url) as Promise<
      PolicyListResponse | (AxiosError | Error)
    >
  }

  // get quotation List
  async getQuotationList({
    brokerNo,
    policyNo,
    eventNo,
    nif,
    product,
    status,
    page,
    output,
  }: GetQuotationyListParams): Promise<
    PolicyListResponse | (AxiosError | Error)
  > {
    let url
    if (output) {
      url = `${APIRoutes.policy.getQuotationList}?brokerNo=${brokerNo}`
    } else {
      url = `${APIRoutes.policy.getQuotationList}?brokerNo=${brokerNo}&skip=${
        page * 50
      }&take=50`
    }

    if (eventNo) {
      url += `&eventNo=${eventNo}`
    }
    if (product) {
      url += `&product=${product}`
    }
    if (status) {
      url += `&status=${status}`
    }
    if (nif) {
      url += `&nif=${nif}`
    }
    if (policyNo) {
      url += `&policyNo=${policyNo}`
    }
    if (output) {
      url += `&output=${output}`
    }

    return ApiProvider.getRequest(url) as Promise<
      PolicyListResponse | (AxiosError | Error)
    >
  }

  // get policy details
  async getPolicy({
    policyNo,
    brokerNo,
  }: {
    policyNo: number
    brokerNo: number
  }): Promise<PolicyListResponse | (AxiosError | Error)> {
    let url = `${APIRoutes.policy.getPolicy}?policyNo=${policyNo}&brokerNo=${brokerNo}`

    return ApiProvider.getRequest(url) as Promise<
      PolicyListResponse | (AxiosError | Error)
    >
  }

  async updatePolicyAddress({
    policyNo,
    body,
  }: UpdatePolicyAddressBody): Promise<
    PolicyListResponse | (AxiosError | Error)
  > {
    const url = `/Policy/ChangePolicyAddress?policyNo=${policyNo}`

    return ApiProvider.postRequest(url, body) as Promise<
      PolicyListResponse | (AxiosError | Error)
    >
  }
}

export const policiesService = new Policies()
